module.exports = __webpack_public_path__ + "static/media/bacteria.15e39f76.png";